// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import logo from "../../assets/logo.png";
import './LogoIcon.style';

export class LogoIcon extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    render() {
        return (
            <>
                <img className='LogoIcon' src={logo} />
            </>
        );
    }
}

export default LogoIcon;
